import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';

//import components
import ItemText from './ItemText.js';

const ItemListInline = ({ clang, list }) => {
    return (
        list && list.map((listItem, index) =>
            <div key={index} className="item__list-inline__item">
                {index === 0 && list.length !== 1 && <ItemText text={`${listItem.label}`} link={listItem.link} type={listItem.entityType} />}
                {index === 0 && list.length !== 1 && <span>,</span>}
                {index === 0 && list.length === 1 && <ItemText text={`${listItem.label}`} link={listItem.link} type={listItem.entityType} />}
                {index !== 0 && index !== list.length - 1 && <ItemText text={`${listItem.label}`} link={listItem.link} type={listItem.entityType}/>}
                {index !== 0 && index !== list.length - 1 && <span>,</span>}
                {index !== 0 && index === list.length - 1 && <ItemText text={`${listItem.label}`} link={listItem.link} type={listItem.entityType} />}
            </div>)
    );
};

ItemListInline.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemListInline);



// WEBPACK FOOTER //
// ./src/components/items/ItemListInline.js